<div class="row" style="padding:0px; background-color:black;margin:0px;">
    <div class="col-lg-1 col-md-1 col-sm-1">
        <img style="max-height:50px;" src="assets/images/ey-logo.png" />
    </div>
    <div class="col-lg-5 col-md-5 col-sm-5">
        <p-menubar [model]="menuitems" [autoDisplay]="false"></p-menubar>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:right;padding-top:10px;">
        <button pButton type="button" label="Resume Cart" class="ui-button-rounded ui-button-warning" icon="fa fa-shopping-cart" (click)="RedirectToResumeCart()"></button>
        <!--<button id="cartButton" pButton type="button" label="{{cartText}}" class="ui-button-rounded ui-button-warning" icon="fa fa-shopping-cart" (click)="RedirectToResumeCart()"></button>-->
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:right;padding-top:10px;">
        <span style="color:white; vertical-align:middle;text-align:center;font-weight:bolder;line-height: 35px;">IN SaT Resume Builder</span>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2" style="text-align:right;">
        <p-menubar [model]="useritems" [autoDisplay]="false"></p-menubar>
    </div>
</div>
<div class="row" style="margin:1px;">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <router-outlet></router-outlet>
    </div>
</div>
